import { SELECT_MEMBER_TYPE, UN_SELECT_MEMBER_TYPE, RE_ORDER_MEMBER_TYPES, ADD_MEMBER_TYPE_REQUEST, ADD_MEMBER_TYPE, DELETE_MEMBER_TYPE, UPDATE_MEMBER_TYPE, ADD_MEMBER_TO_MEMBER_TYPE, REMOVE_MEMBER_FROM_MEMBER_TYPE, SELECT_MEMBER_TYPE_CUSTOM_FIELD, UN_SELECT_MEMBER_TYPE_CUSTOM_FIELD, ADD_MEMBER_TYPE_CUSTOM_FIELD, DELETE_MEMBER_TYPE_CUSTOM_FIELD, UPDATE_MEMBER_TYPE_CUSTOM_FIELD, SELECT_MEMBER_TYPE_CUSTOM_FIELD_OPTION, UN_SELECT_MEMBER_TYPE_CUSTOM_FIELD_OPTION, RE_ORDER_MEMBER_TYPE_CUSTOM_FIELD_OPTION, ADD_MEMBER_TYPE_CUSTOM_FIELD_OPTION, DELETE_MEMBER_TYPE_CUSTOM_FIELD_OPTION, UPDATE_MEMBER_TYPE_CUSTOM_FIELD_OPTION, INewMemberTypeData, IUpdateableMemberTypeData, UPDATE_MEMBER_TYPE_CUSTOM_FIELD_START_PIECE, SET_ISOLATED_MEMBER_TYPE_CUSTOM_FIELD_PIECE, REMOVE_ISOLATED_MEMBER_TYPE_CUSTOM_FIELD_PIECE, REGISTER_MEMBER_TYPE_CUSTOM_FIELD_VARIABLE, ADD_MEMBER_TYPE_MANAGEMENT_CUSTOM_FIELD_MAP_FOR_ADD, UPDATE_MEMBER_TYPE_MANAGEMENT_FOR_ADD, DISCARD_MEMBER_TYPE_MANAGEMENT_FOR_ADD, ADD_MEMBER_TYPE_MANAGEMENT_CUSTOM_FIELD_MAP_FOR_UPDATE, UPDATE_MEMBER_TYPE_MANAGEMENT_FOR_UPDATE, DISCARD_MEMBER_TYPE_MANAGEMENT_FOR_UPDATE, SelectMemberTypeAction, UnSelectMemberTypeAction, ReOrderMemberTypesAction, AddMemberTypeRequestAction, AddMemberTypeAction, UpdateMemberTypeAction, DeleteMemberTypeAction, AddMemberToMemberTypeAction, RemoveMemberFromMemberTypeAction, SelectMemberTypeCustomFieldAction, UnSelectMemberTypeCustomFieldAction, AddMemberTypeCustomFieldAction, DeleteMemberTypeCustomFieldAction, UpdateMemberTypeCustomFieldAction, UpdateMemberTypeCustomFieldStartPieceAction, SetIsolatedMemberTypeCustomFieldPieceAction, RemoveIsolatedMemberTypeCustomFieldPieceAction, RegisterMemberTypeCustomFieldVariableAction, SelectMemberTypeCustomFieldOptionAction, UnSelectMemberTypeCustomFieldOptionAction, ReOrderMemberTypeCustomFieldOptionAction, AddMemberTypeCustomFieldOptionAction, DeleteMemberTypeCustomFieldOptionAction, UpdateMemberTypeCustomFieldOptionAction, AddMemberTypeManagementCustomFieldMapForAddAction, UpdateMemberTypeManagementForAddAction, DiscardMemberTypeManagementForAddAction, UpdateMemberTypeManagementForUpdateAction, DiscardMemberTypeManagementForUpdateAction, AddMemberTypeManagementCustomFieldMapForUpdateAction, IMemberType, InstantiateMemberTypeAction, INSTANTIATE_MEMBER_TYPE, InstantiateMemberTypeCustomFieldAction, INSTANTIATE_MEMBER_TYPE_CUSTOM_FIELD, InstantiateMemberTypeCustomFieldOptionAction, INSTANTIATE_MEMBER_TYPE_CUSTOM_FIELD_OPTION, AddActionToMemberTypeAction, ADD_ACTION_TO_MEMBER_TYPE, REMOVE_ACTION_FROM_MEMBER_TYPE, RemoveActionFromMemberTypeAction, BulkAddMembersToMemberTypesAction, BULK_ADD_MEMBERS_TO_MEMBER_TYPES, MemberToTypeLink, BulkRemoveMembersFromMemberTypesAction, BULK_REMOVE_MEMBERS_FROM_MEMBER_TYPES } from './types';
import { INewFieldChoiceData, IUpdateableFieldChoiceData, INewCustomFieldData, IUpdateableCustomFieldData, CustomField, FieldChoice } from '../../custom-fields/types';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { PiecePositionState } from '../../../helpers/common-types';

export function selectMemberType(id: string): SelectMemberTypeAction {
    return {
        type: SELECT_MEMBER_TYPE,
        id,
    }
}

export function unSelectMemberType(): UnSelectMemberTypeAction {
    return {
        type: UN_SELECT_MEMBER_TYPE,
    }
}

export function reOrderMemberTypes(sourceIndex: number, destinationIndex: number): ReOrderMemberTypesAction {
    return {
        type: RE_ORDER_MEMBER_TYPES,
        sourceIndex,
        destinationIndex,
    }
}

export function addMemberTypeRequest(payload: INewMemberTypeData): AddMemberTypeRequestAction {
    return {
        type: ADD_MEMBER_TYPE_REQUEST,
        payload,
    }
}

export function addMemberType(payload: INewMemberTypeData): AddMemberTypeAction {
    const now = moment.utc().format();

    return {
        type: ADD_MEMBER_TYPE,
        payload: {
            id: uuidv4(),
            ...payload,
            createdTime: now,
            lastUpdatedTime: now,
            customFields: [],
            members: [],
            actions: [],
        },
        currentTime: now,
    }
}

export function instantiateMemberType(payload: IMemberType): InstantiateMemberTypeAction {
    const now = moment.utc().format();
    return {
        type: INSTANTIATE_MEMBER_TYPE,
        payload,
        currentTime: now,
    }
}

export function updateMemberType(payload: IUpdateableMemberTypeData): UpdateMemberTypeAction {
    return {
        type: UPDATE_MEMBER_TYPE,
        payload,
        currentTime: moment.utc().format(),
    }
}

export function deleteMemberType(id: string): DeleteMemberTypeAction {
    return {
        type: DELETE_MEMBER_TYPE,
        id,
        currentTime: moment.utc().format(),
    }
}

export function addActionToMemberType(actionId: string, memberTypeId: string): AddActionToMemberTypeAction {
    return {
        type: ADD_ACTION_TO_MEMBER_TYPE,
        memberTypeId,
        actionId,
    }
}

export function removeActionFromMemberType(actionId: string, memberTypeId: string): RemoveActionFromMemberTypeAction {
    return {
        type: REMOVE_ACTION_FROM_MEMBER_TYPE,
        memberTypeId,
        actionId,
    }
}

export function addMemberToMemberType(memberId: string, memberTypeId: string): AddMemberToMemberTypeAction {
    return {
        type: ADD_MEMBER_TO_MEMBER_TYPE,
        memberTypeId,
        memberId,
    }
}

export function removeMemberFromMemberType(memberId: string, memberTypeId: string): RemoveMemberFromMemberTypeAction {
    return {
        type: REMOVE_MEMBER_FROM_MEMBER_TYPE,
        memberTypeId,
        memberId,
    }
}

export function bulkAddMembersToMemberTypes(links: Array<MemberToTypeLink>): BulkAddMembersToMemberTypesAction {
    return {
        type: BULK_ADD_MEMBERS_TO_MEMBER_TYPES,
        links,
    }
}

export function bulkRemoveMembersFromMemberTypes(links: Array<MemberToTypeLink>): BulkRemoveMembersFromMemberTypesAction {
    return {
        type: BULK_REMOVE_MEMBERS_FROM_MEMBER_TYPES,
        links,
    }
}

export function selectMemberTypeCustomField(id: string): SelectMemberTypeCustomFieldAction {
    return {
        type: SELECT_MEMBER_TYPE_CUSTOM_FIELD,
        id,
    }
}

export function unSelectMemberTypeCustomField(): UnSelectMemberTypeCustomFieldAction {
    return {
        type: UN_SELECT_MEMBER_TYPE_CUSTOM_FIELD,
    }
}

export function addMemberTypeCustomField(payload: INewCustomFieldData, memberTypeId: string): AddMemberTypeCustomFieldAction {
    return {
        type: ADD_MEMBER_TYPE_CUSTOM_FIELD,
        payload: {
            id: uuidv4(),
            ...payload,
        },
        memberTypeId,
        currentTime: moment.utc().format(),
    }
}

export function instantiateMemberTypeCustomField(payload: CustomField, memberTypeId: string): InstantiateMemberTypeCustomFieldAction {
    const now = moment.utc().format();

    return {
        type: INSTANTIATE_MEMBER_TYPE_CUSTOM_FIELD,
        payload,
        memberTypeId,
        currentTime: now,
    }
}

export function deleteMemberTypeCustomField(id: string, memberTypeId: string): DeleteMemberTypeCustomFieldAction {
    return {
        type: DELETE_MEMBER_TYPE_CUSTOM_FIELD,
        id,
        memberTypeId,
        currentTime: moment.utc().format(),
    }
}

export function updateMemberTypeCustomField(payload: IUpdateableCustomFieldData): UpdateMemberTypeCustomFieldAction {
    return {
        type: UPDATE_MEMBER_TYPE_CUSTOM_FIELD,
        payload,
        currentTime: moment.utc().format(),
    }
}

export function updateMemberTypeCustomFieldStartPiece(payload: PiecePositionState, customFieldId: string): UpdateMemberTypeCustomFieldStartPieceAction {
    return {
        type: UPDATE_MEMBER_TYPE_CUSTOM_FIELD_START_PIECE,
        payload,
        customFieldId,
        currentTime: moment.utc().format(),
    }
}

export function setIsolatedMemberTypeCustomFieldPiece(payload: PiecePositionState, customFieldId: string): SetIsolatedMemberTypeCustomFieldPieceAction {
    return {
        type: SET_ISOLATED_MEMBER_TYPE_CUSTOM_FIELD_PIECE,
        payload,
        customFieldId,
        currentTime: moment.utc().format(),
    }
}

export function removeIsolatedMemberTypeCustomFieldPiece(pieceId: string, customFieldId: string): RemoveIsolatedMemberTypeCustomFieldPieceAction {
    return {
        type: REMOVE_ISOLATED_MEMBER_TYPE_CUSTOM_FIELD_PIECE,
        pieceId,
        customFieldId,
        currentTime: moment.utc().format(),
    }
}

export function registerMemberTypeCustomFieldVariable(variableId: string, customFieldId: string): RegisterMemberTypeCustomFieldVariableAction {
    return {
        type: REGISTER_MEMBER_TYPE_CUSTOM_FIELD_VARIABLE,
        variableId,
        customFieldId,
        currentTime: moment.utc().format(),
    }
}


export function selectMemberTypeCustomFieldOption(id: string): SelectMemberTypeCustomFieldOptionAction {
    return {
        type: SELECT_MEMBER_TYPE_CUSTOM_FIELD_OPTION,
        id,
    }
}

export function unSelectMemberTypeCustomFieldOption(): UnSelectMemberTypeCustomFieldOptionAction {
    return {
        type: UN_SELECT_MEMBER_TYPE_CUSTOM_FIELD_OPTION,
    }
}

export function reOrderMemberTypeCustomFieldOption(sourceIndex: number, destinationIndex: number, parentId: string): ReOrderMemberTypeCustomFieldOptionAction {
    return {
        type: RE_ORDER_MEMBER_TYPE_CUSTOM_FIELD_OPTION,
        sourceIndex,
        destinationIndex,
        parentId,
    }
}

export function addMemberTypeCustomFieldOption(payload: INewFieldChoiceData, parentId: string): AddMemberTypeCustomFieldOptionAction {
    return {
        type: ADD_MEMBER_TYPE_CUSTOM_FIELD_OPTION,
        payload: {
            id: uuidv4(),
            ...payload,
        },
        parentId,
        currentTime: moment.utc().format(),
    }
}

export function instantiateMemberTypeCustomFieldOption(payload: FieldChoice, parentId: string): InstantiateMemberTypeCustomFieldOptionAction {
    return {
        type: INSTANTIATE_MEMBER_TYPE_CUSTOM_FIELD_OPTION,
        payload,
        parentId,
        currentTime: moment.utc().format(),
    }
}

export function deleteMemberTypeCustomFieldOption(id: string, parentId: string): DeleteMemberTypeCustomFieldOptionAction {
    return {
        type: DELETE_MEMBER_TYPE_CUSTOM_FIELD_OPTION,
        id,
        parentId,
        currentTime: moment.utc().format(),
    }
}

export function updateMemberTypeCustomFieldOption(payload: IUpdateableFieldChoiceData): UpdateMemberTypeCustomFieldOptionAction {
    return {
        type: UPDATE_MEMBER_TYPE_CUSTOM_FIELD_OPTION,
        payload,
        currentTime: moment.utc().format(),
    }
}

export function addMemberTypeManagementCustomFieldMapForAdd(memberTypeId: string, memberTypeCustomFieldId: string, workflowTypeCustomFieldId: string): AddMemberTypeManagementCustomFieldMapForAddAction {
    return {
        type: ADD_MEMBER_TYPE_MANAGEMENT_CUSTOM_FIELD_MAP_FOR_ADD,
        memberTypeId,
        memberTypeCustomFieldId,
        workflowTypeCustomFieldId,
    }
}

export function addMemberTypeManagementCustomFieldMapForUpdate(memberTypeId: string, memberTypeCustomFieldId: string, workflowTypeCustomFieldId: string): AddMemberTypeManagementCustomFieldMapForUpdateAction {
    return {
        type: ADD_MEMBER_TYPE_MANAGEMENT_CUSTOM_FIELD_MAP_FOR_UPDATE,
        memberTypeId,
        memberTypeCustomFieldId,
        workflowTypeCustomFieldId,
    }
}

export function updateMemberTypeManagementForAdd(memberTypeId: string, workflowTypeId: string, lastQuestionPieceId: string, lastStorePieceId: string): UpdateMemberTypeManagementForAddAction {
    return {
        type: UPDATE_MEMBER_TYPE_MANAGEMENT_FOR_ADD,
        memberTypeId,
        workflowTypeId,
        lastQuestionPieceId,
        lastStorePieceId,
    }
}

export function discardGroupTypeManagementForAdd(memberTypeId: string): DiscardMemberTypeManagementForAddAction {
    return {
        type: DISCARD_MEMBER_TYPE_MANAGEMENT_FOR_ADD,
        memberTypeId,
    }
}

export function updateMemberTypeManagementForUpdate(memberTypeId: string, workflowTypeId: string, lastQuestionPieceId: string, lastStorePieceId: string): UpdateMemberTypeManagementForUpdateAction {
    return {
        type: UPDATE_MEMBER_TYPE_MANAGEMENT_FOR_UPDATE,
        memberTypeId,
        workflowTypeId,
        lastQuestionPieceId,
        lastStorePieceId,
    }
}

export function discardGroupTypeManagementForUpdate(memberTypeId: string): DiscardMemberTypeManagementForUpdateAction {
    return {
        type: DISCARD_MEMBER_TYPE_MANAGEMENT_FOR_UPDATE,
        memberTypeId,
    }
}